import { CURRENCIES_META } from '@mint-lib/currencies-helpers';

import { CurrencyItemRaw } from '../../../../redux/reducer/campaigns/types.js';
import { Option } from './types.js';

export const prepareOptionList = (options?: CurrencyItemRaw[]): Option[] => {
  if (!options) {
    return [];
  }

  const preparedOptions = options.map((item) => {
    const { symbol, code } = CURRENCIES_META[item.code];
    return {
      label: `${symbol} (${code})`,
      value: code,
    };
  });

  return preparedOptions;
};
